import React from 'react';
import PharmacyItemsTable from './common/PharmacyItemsTable';
import { PharmacyItem as FormPharmacyItem, PackageDetail } from './dispenseHelper';
import { PharmacyItem as ApiPharmacyItem } from '../Billing/Pharmacy/newPharmacy/ItemSearchField';

interface ItemsListProps {
  items: FormPharmacyItem[];
  onSelectChange: (index: number) => void;
  /** Callback to select/deselect all items */
  onSelectAll?: (selectAll: boolean) => void;
  onRemoveItem: (index: number) => void;
  onFieldChange: (index: number, field: keyof FormPharmacyItem, value: string | number) => void;
  onItemUpdate?: (index: number, updates: Partial<FormPharmacyItem>) => void;
  errors?: Array<Record<string, string>>;
  touched?: Array<Record<string, boolean>>;
  onQtyErrorChange?: (hasError: boolean) => void;
  /** Callback when user selects a replacement item for rows with no available batches */
  onItemReplace?: (index: number, item: ApiPharmacyItem) => void;
  /** Clinic ID for item search (used when replacing items) */
  clinicId?: number;
  /** Department/Store ID for item search (used when replacing items) */
  deptId?: number | null;
  /** Patient ID for item search (used when replacing items) */
  patientId?: number | null;
  /** Callback when package is selected for an item */
  onPackageChange?: (index: number, packageDetail: PackageDetail | null) => void;
  /** If true, disables batch selection dropdown (for QR scan mode) */
  disableBatchSelection?: boolean;
  /** Callback when user clicks duplicate button to add another line for same item */
  onDuplicateItem?: (index: number) => void;
}

/**
 * ItemsList - Displays current pharmacy items for billing
 * Uses the common PharmacyItemsTable with full billing columns enabled
 */
const ItemsList: React.FC<ItemsListProps> = ({
  items,
  onSelectChange,
  onSelectAll,
  onRemoveItem,
  onFieldChange,
  onItemUpdate,
  errors = [],
  touched = [],
  onQtyErrorChange,
  onItemReplace,
  clinicId,
  deptId,
  patientId,
  onPackageChange,
  disableBatchSelection,
  onDuplicateItem,
}) => {
  return (
    <PharmacyItemsTable
      items={items}
      onSelectChange={onSelectChange}
      onSelectAll={onSelectAll}
      onRemoveItem={onRemoveItem}
      onFieldChange={onFieldChange}
      onItemUpdate={onItemUpdate}
      errors={errors}
      touched={touched}
      showDeleteAction={true}
      readOnly={false}
      onQtyErrorChange={onQtyErrorChange}
      onItemReplace={onItemReplace}
      clinicId={clinicId}
      deptId={deptId}
      patientId={patientId}
      onPackageChange={onPackageChange}
      disableBatchSelection={disableBatchSelection}
      onDuplicateItem={onDuplicateItem}
    />
  );
};

export default ItemsList;
